import type { SubscriptionTier, DowngradeSubscriptionInput, CancelSubscriptionInput, SubscriptionChangeType } from '@maker-toolchest/shared';
import { api } from './api';

interface SubscriptionResponse {
  tier: SubscriptionTier;
  scheduledTier: SubscriptionTier | null;
  tierChangeDate: Date | null;
  scheduledChangeType: SubscriptionChangeType | null;
}

export const subscriptionApi = {
  /**
   * Upgrade to the next tier
   * In dev/staging: directly upgrades
   * In production: creates Stripe checkout session (TODO)
   */
  async upgradeTier(): Promise<SubscriptionResponse> {
    const response = await api.post<SubscriptionResponse>(
      '/subscription/upgrade'
    );
    if (!response.data) {
      throw new Error('Failed to upgrade tier');
    }
    return response.data;
  },

  /**
   * Downgrade to a lower tier (schedules for renewal date)
   */
  async downgradeTier(input: DowngradeSubscriptionInput): Promise<SubscriptionResponse> {
    const response = await api.post<SubscriptionResponse>(
      '/subscription/downgrade',
      input
    );
    if (!response.data) {
      throw new Error('Failed to downgrade tier');
    }
    return response.data;
  },

  /**
   * Cancel subscription (downgrade to free tier)
   */
  async cancelSubscription(input: CancelSubscriptionInput): Promise<SubscriptionResponse> {
    const response = await api.post<SubscriptionResponse>(
      '/subscription/cancel',
      input
    );
    if (!response.data) {
      throw new Error('Failed to cancel subscription');
    }
    return response.data;
  },

  /**
   * Cancel a scheduled tier change
   */
  async cancelScheduledChange(): Promise<SubscriptionResponse> {
    const response = await api.post<SubscriptionResponse>(
      '/subscription/cancel-scheduled-change'
    );
    if (!response.data) {
      throw new Error('Failed to cancel scheduled change');
    }
    return response.data;
  },
};
